import React from 'react';

import AppearancePageContent
  from 'components/dashboard/appearance-content/AppearancePageContent';

const DashboardAppearancePage = () => <AppearancePageContent />;

export default DashboardAppearancePage;
